import { render, staticRenderFns } from "./ListRequests.vue?vue&type=template&id=a600d4aa&scoped=true"
import script from "./ListRequests.vue?vue&type=script&lang=ts"
export * from "./ListRequests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a600d4aa",
  null
  
)

export default component.exports